<script>
import dayjs from '../../core/dayjs'
import IconCopy from '../icon/Copy';
import { mask } from 'vue-the-mask';

export default {
  directives: {
    mask,
  },

  components: {
    IconCopy,
  },

  props: {
    /**
     * The barcode link of bankslip
     */
    barcode: {
      type: String,
      required: true,
    },

    /**
     * The digitable of bankslip
     */
    digitableLine: {
      type: String,
      required: true,
    },

    /**
     * The dueat of bankslip
     */
    dueat: {
      type: String,
      required: true,
    },

    /**
     * The price of bankslip
     */
    price: {
      type: String,
      required: true,
    },

    /**
     * The name of customer
     */
    customerName: {
      type: String,
      required: true,
    },

    /**
     * The document of customer
     */
    customerDocument: {
      type: String,
      required: true,
    },
  },

  computed: {
    expiryAt () {
      return dayjs(this.dueat, 'DD/MM/YYYY').add(5, 'day').format('DD/MM/YYYY');
    },
  },

  methods: {
    print () {
      window.print();
    },
  },
};
</script>

<template>
  <div
    class="bdk-bankslip bdk-mt-3"
  >
    <div
      class="bdk-w-full bdk-grid bdk-grid-cols-8 bdk-gap-2"
    >
      <div
        class="bdk-flex bdk-items-center bdk-justify-center"
      >
        <img
          class="bdk-w- bdk-h-14"
          src="https://i.pinimg.com/originals/ce/2c/d0/ce2cd05adb55a2e2e4c6cb22b9c5a8cc.png"
        />
      </div>

      <div
        class="bdk-flex bdk-flex-col bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-4 bdk-col-span-7"
      >
        <div
          class="bdk-text-sm bdk-text-gray-900 bdk-whitespace-nowrap bdk-text-opacity-80 bdk-font-semibold bdk-flex-shrink-0 bdk-flex bdk-w-1/6"
        >
          BANCO BRADESCO SA.

          <span
            class="bdk-text-gray-400 bdk-ml-4"
          >
            237
          </span>
        </div>

        <div
          v-text="digitableLine"
        />
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-px-4 bdk-flex bdk-flex-col bdk-col-span-6"
      >
        <span
          v-text="__('Local de Pagamento')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          class="bdk-text-sm"
          v-text="__('Pagável em qualquer banco ou lotérica')"
        />
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-flex bdk-flex-col bdk-col-span-2"
      >
        <span
          v-text="__('Nosso Número')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          class="bdk-text-sm"
        >
          -
        </span>
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-flex bdk-flex-col bdk-col-span-3"
      >
        <span
          v-text="__('Cedente')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          class="bdk-text-sm"
        >
          5LABS
        </span>

        <span
          class="bdk-text-xs"
        >
          45.781.022/0001-74
        </span>
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-flex bdk-flex-col bdk-col-span-3"
      >
        <span
          v-text="__('Intermediador')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          class="bdk-uppercase bdk-text-sm"
        >
          Iugu Serviços na Internet SA
        </span>

        <span
          class="bdk-text-xs"
        >
          15.111.975/0001-64
        </span>
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-flex bdk-flex-col bdk-col-span-2"
      >
        <span
          v-text="__('Vencimento')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          v-text="dueat"
          class="bdk-text-sm"
        />
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-flex bdk-flex-col bdk-col-span-6"
      >
        <div
          v-text="__('Instruções')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          class="bdk-text-sm"
        >
          Não receber após o dia {{ expiryAt }}
        </span>
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-flex bdk-flex-col bdk-col-span-2"
      >
        <span
          v-text="__('Multa/Juros')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          class="bdk-text-sm"
        >
          -
        </span>
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-flex bdk-flex-col bdk-col-span-6"
      >
        <div
          v-text="__('Cliente')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          class="bdk-text-sm"
          v-text="customerName"
        />

        <input
          readonly
          :value="customerDocument"
          v-mask="['###.###.###-##', '##.###.###/####-##']"
          class="bdk-text-xs bdk-text-left bdk-outline-none bdk-p-0"
        />
      </div>

      <div
        class="bdk-border-b bdk-border-l bdk-rounded-bl-md bdk-border-gray-200 bdk-pl-6 bdk-py-2 bdk-flex bdk-flex-col bdk-col-span-2"
      >
        <span
          v-text="__('Valor Total')"
          class="bdk-text-xs bdk-leading-6 bdk-font-medium bdk-text-gray-500 bdk-uppercase"
        />

        <span
          v-text="price"
          class="bdk-text-sm"
        />
      </div>
    </div>

    <div
      class="bdk-space-y-1 bdk-mt-6 bdk-flex bdk-px-4"
    >
      <div
        class="bdk-payment__barcode bdk-flex bdk-flex-col bdk-items-center"
      >
        <div
          class="bdk-flex bdk-flex-col bdk-items-center bdk-no-print"
        >
          <p
            class="bdk-text-base bdk-text-gray-500 bdk-mb-1"
            v-text=" __( 'Use o código de barras para pagar no app ou internet banking')"
          />

          <a
            :data-clipboard-text="digitableLine"
            class="bdk-text-sm bd-copy bdk-cursor-pointer bdk-flex bdk-items-center"
          >
            <IconCopy class="bdk-mr-1" />

            {{ digitableLine }}
          </a>
        </div>

        <div
          class="bdk-flex bdk-flex-col bdk-items-center bdk-hidden bdk-on-print"
        >
          <p
            class="bdk-text-sm bdk-text-gray-500 bdk-text-center bdk-mb-1"
            v-text=" __( 'Linha Digitável')"
          />

          <span
            v-text="digitableLine"
            class="bdk-text-xs bdk-whitespace-nowrap"
          />
        </div>

        <img
          :src="barcode"
          class="bdk-payment__barcode-img bdk-object-cover bdk-rounded-lg bdk-flex-1"
        />
      </div>

      <div
        class="bdk-rounded-md bdk-ml-auto bdk-no-print"
      >
        <a
          @click.prevent="print"
          v-text="__('Imprimir')"
          class="bd-copy bdk-cursor-pointer bdk-flex bdk-items-center bdk-justify-center bdk-px-5 bdk-py-3 bdk-border bdk-border-transparent bdk-text-base bdk-font-medium bdk-rounded-md bdk-text-white bdk-bg-gray-800 hover:bdk-bg-gray-900"
        />
      </div>

      <div
        class="bdk-on-print bdk-rounded-tl-md bdk-ml-2 bdk-hidden bdk-w-full bdk-border-t bdk-border-l bdk-border-gray-200 bdk-flex bdk-justify-center"
      >
        <p
          class="bdk-text-sm bdk-text-gray-500 bdk-text-center bdk-mb-1 bdk-uppercase bdk-mt-2"
          v-text=" __( 'Autenticação Mecânica')"
        />

      </div>
    </div>
  </div>
</template>
